initMarquees();
function initMarquees() {
  const marquees = document.querySelectorAll(".marquee-outer");

  // Duplicate inner content until it fills the availabile width
  for (const marquee of marquees) {
    const inner = marquee.querySelector(".inner");
    const marqueeWidth = marquee.scrollWidth * 2;
    const p = marquee.querySelector("p");
    const ps = marquee.querySelectorAll("p");
    const pWidth = p.scrollWidth;
    let marqueeInner = p.scrollWidth * 4;

    if (marqueeInner < marqueeWidth) {
      const cloned = p.cloneNode(true);

      while (marqueeInner < marqueeWidth) {
        inner.appendChild(cloned);
        marqueeInner = marqueeInner + pWidth;
      }
    }

    // Animate using Web Animations API
    const lineMoving = [
      { transform: "translateX(-50%)" },
      { transform: "translateX(-150%)" },
    ];

    const lineTiming = {
      duration: (p.textContent.length * 1000) / 5 || 7500,
      iterations: Infinity,
    };

    // Check if p.animate works, otherwise add class to animate with CSS
    if (p.animate) {
      let animeArray = [];

      ps.forEach((para) => {
        const anime = para.animate(lineMoving, lineTiming);
        anime.pause();
        animeArray.push(anime);
      });

      // Create intersection observer to pause animation when not in view
      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animeArray.forEach((a) => {
              a.play();
            });
          } else {
            animeArray.forEach((a) => {
              a.pause();
            });
          }
        });
      });

      intersectionObserver.observe(marquee);
    } else {
      // CSS backup
      marquee.classList.add("css-animate");
    }
  }
}
